import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
var CasePracticeInfluenceComponent = (function () {
    function CasePracticeInfluenceComponent(route, router, apiService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
    }
    CasePracticeInfluenceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userType = window.sessionStorage.getItem('userType');
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.learningPathId = params['learningPathId'];
            _this.practiceMetaId = params['practiceMetaId'];
            _this.exerciseId = params['exerciseId'];
            if (_this.userType) {
                window.sessionStorage.setItem('visitorPracticeMetaId', _this.practiceMetaId + '');
            }
            else {
                window.sessionStorage.removeItem('visitorPracticeMetaId');
            }
            if (_this.exerciseId > 0 || localStorage.getItem('isIframe')) {
                _this.page = 'begin';
            }
            else {
                _this.page = 'list';
            }
            console.log(_this.learningPathId);
            if (_this.practiceMetaId !== 0) {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/createAndGet/' + _this.learningPathId + '/' + _this.practiceMetaId
                }).subscribe(function (result) {
                    $('#exerciseMetaId').val(result.exercise[0].exerciseMetaId);
                    _this.practiceList = result.exercise;
                    _this.practiceId = result.id;
                    _this.apiService.ajax({
                        'type': 'post',
                        'url': 'sr/practice/correctLearningPath/' + _this.practiceId,
                        'data': { 'practiceId': _this.practiceId }
                    }).subscribe();
                });
            }
        });
        setTimeout(function () {
            if (_this.type) {
                $('#userIdContainer').val(JSON.parse(localStorage.getItem('userInfo'))['userId']);
                $('#learningPathMetaIdContainer').val();
            }
        }, 500);
    };
    CasePracticeInfluenceComponent.prototype.setPracticeIndex = function (i) {
        this.practiceIndex = i;
        this.exerciseId = this.practiceList[this.practiceIndex].id;
    };
    CasePracticeInfluenceComponent.prototype.goToNextStep = function (i) {
        if (i == 1) {
            this.page = 'begin';
        }
        else if (i == 2) {
            this.page = 'main';
        }
    };
    CasePracticeInfluenceComponent.prototype.getMockData = function () {
        return {
            "id": 1955,
            "exercise": [{
                    "id": 2253,
                    "title": "\u62a5\u544a\u8fdf\u4ea4\uff0c\u8c01\u4e4b\u8fc7?",
                    "description": "\u4e00\u4e2a\u52e4\u594b\u4f46\u73bb\u7483\u5fc3\u7684\u5458\u5de5\u7531\u4e8e\u8fdf\u4ea4\u62a5\u544a\u5f15\u53d1\u7684\u4e00\u7cfb\u5217\u7684\u6545\u4e8b",
                    "status": 1
                }, {
                    "id": 2254,
                    "title": "\u5458\u5de5\u60c5\u7eea\uff0c\u5982\u4f55\u5316\u8d1f\u4e3a\u6b63",
                    "description": "\u5982\u4f55\u8f85\u5bfc\u4e00\u4e2a\u5e26\u6709\u8d1f\u9762\u60c5\u7eea\u7684\u8001\u5458\u5de5\uff1f\u8fd9\u662f\u4e2a\u5e38\u89c1\u7684\u95ee\u9898\uff0c\u8981\u600e\u4e48\u505a\u5462\uff1f",
                    "status": 1
                }]
        };
    };
    return CasePracticeInfluenceComponent;
}());
export { CasePracticeInfluenceComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-influence/case-practice-influence.component.ts.pre-build-optimizer.js